export enum SeverityReason {
  Answer = "Pacient zvolil závážnou odpověď",
  HeartRate = "Pacient překročil stanovené meze tepu",
  Pressure = "Pacient překročil stanovené meze tlaku",
}
